import { ReactComponent as LogoLight } from "../../../../assets/images/icomply-logo-light.svg";
import { ReactComponent as DashboardIcon } from "../../../../assets/icons/dashboard-icon.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/icons/search-icon.svg";
import { ReactComponent as MembersIcon } from "../../../../assets/icons/members-icon.svg";
import { ReactComponent as TasksIcon } from "../../../../assets/icons/tasks-icon.svg";
import { ReactComponent as FormsIcon } from "../../../../assets/icons/forms-icon.svg";
import { ReactComponent as ShortLogo } from "../../../../assets/icons/logo-short.svg";
import { ReactComponent as FrontDeskIcon } from "../../../../assets/icons/front-desk-icon.svg";
import { ReactComponent as ActivityLogIcon } from "../../../../assets/icons/activity-icon.svg";
import { Link } from "react-router-dom";
import {
    ACTIVITY_LOGS_ROUTE,
    ADD_MEMBERS_ROUTE,
    DOWNLOADABLE_FORMS_ROUTE,
    FORMS_LIST_ROUTE,
    FREE_ALERT_SUBSCRIBER_LIST_ROUTE,
    FRONT_DESK_FORM_LIST_ROUTE,
    FRONT_DESK_SUBMITTED_FORMS_ROUTE,
    MEMBER_OVERVIEW_ROUTE,
    SEARCH_QUERY_TOOL_ROUTE,
    SUBMITTED_FORMS_ROUTE,
    SUBSCRIBER_LIST_ROUTE,
    TASKS_ROUTE,
} from "../../dashboard-routes";
import "./dashboard-sidebar.scss";
import { useState } from "react";
import authServices from "../../../../services/authServices";

const DashboardSidebar = ({ url, isOpen = false, toggle }) => {
    const sidebarWidth = isOpen ? 256 : 64;
    const headerHeight = 64;

    function openSidebar() {
        if (!isOpen) toggle(true);
    }

    return (
        <div
            id="dashboard-sidebar"
            className="bg-secondary"
            style={{ width: sidebarWidth + "px", minHeight: "100vh", transition: "all 300ms ease-out" }}
            onClick={openSidebar}
        >
            <div
                className="logo d-flex align-items-center justify-content-center"
                style={{
                    height: headerHeight,
                    backgroundColor: "hsla(191, 58%, 7%, 1)",
                }}
            >
                {isOpen ? (
                    <div className="d-flex align-items-center justify-content-center">
                        <LogoLight />
                    </div>
                ) : (
                    <div
                        className="d-flex align-items-center justify-content-center"
                        style={{ width: "64px", height: "64px" }}
                    >
                        <ShortLogo width="32" />
                    </div>
                )}
            </div>

            <div>
                <div className="accordion" id="menuContainer">
                    {/* Dashboard */}

                    <div className="accordion-item bg-transparent">
                        <div className="accordion-header bg-transparent" id="dashboardItem" style={{ width: "256px" }}>
                            <button
                                className="accordion-button bg-transparent text-light collapsed no-border p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#dashboardCollapse"
                                aria-expanded="true"
                                aria-controls="dashboardCollapse"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <DashboardIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Dashboard</div>
                            </button>
                        </div>

                        <div
                            id="dashboardCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="dashboardItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url}>
                                    <div className="item text-light p-3">Overview</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Forms */}

                    <div className="accordion-item bg-transparent">
                        <div className="accordion-header bg-transparent" id="formItem" style={{ width: "256px" }}>
                            <button
                                className="accordion-button bg-transparent text-light no-border collapsed p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#formsCollapse"
                                aria-controls="formsCollapse"
                                aria-expanded="false"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <FormsIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Forms</div>
                            </button>
                        </div>
                        <div
                            id="formsCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="formItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url + FORMS_LIST_ROUTE}>
                                    <div className="item text-light p-3">List of Forms</div>
                                </Link>
                                <Link to={url + DOWNLOADABLE_FORMS_ROUTE}>
                                    <div className="item text-light p-3">Downloadable Forms</div>
                                </Link>
                                <Link to={url + SUBMITTED_FORMS_ROUTE}>
                                    <div className="item text-light p-3">Submitted Forms</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Members */}

                    <div className="accordion-item bg-transparent">
                        <div className="accordion-header bg-transparent" id="memberItem" style={{ width: "256px" }}>
                            <button
                                className="accordion-button bg-transparent text-light no-border collapsed p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#memberCollapse"
                                aria-controls="memberCollapse"
                                aria-expanded="false"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <MembersIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Members</div>
                            </button>
                        </div>
                        <div
                            id="memberCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="memberItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url + MEMBER_OVERVIEW_ROUTE}>
                                    <div className="item text-light p-3">Overview</div>
                                </Link>

                                <Link to={url + ADD_MEMBERS_ROUTE}>
                                    <div className="item text-light p-3">Add members</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Tasks */}

                    <div className="accordion-item bg-transparent">
                        <div className="accordion-header bg-transparent" id="taskItem" style={{ width: "256px" }}>
                            <button
                                className="accordion-button bg-transparent text-light no-border collapsed p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#taskCollapse"
                                aria-expanded="false"
                                aria-controls="taskCollapse"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <TasksIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Tasks</div>
                            </button>
                        </div>
                        <div
                            id="taskCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="taskItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url + TASKS_ROUTE}>
                                    <div className="item text-light p-3">Overview</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Activity Log */}

                    <div className="accordion-item bg-transparent">
                        <div
                            className="accordion-header bg-transparent"
                            id="activityLogItem"
                            style={{ width: "256px" }}
                        >
                            <button
                                className="accordion-button bg-transparent text-light no-border collapsed p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#activityLogCollapse"
                                aria-controls="activityLogCollapse"
                                aria-expanded="false"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <ActivityLogIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Activity Log</div>
                            </button>
                        </div>
                        <div
                            id="activityLogCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="activityLogItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url + ACTIVITY_LOGS_ROUTE}>
                                    <div className="item text-light p-3">Overview</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Search query tool */}

                    <div className="bg-transparent" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }}>
                        <div className="bg-transparent" id="searchItem" style={{ width: "256px" }}>
                            <Link to={url + SEARCH_QUERY_TOOL_ROUTE}>
                                <button
                                    className="btn search-btn d-flex align-items-center bg-transparent text-light no-border w-100 p-0"
                                    type="button"
                                    aria-expanded="true"
                                    aria-controls="collapseTwo"
                                >
                                    <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{ width: "4rem", height: "4rem" }}
                                    >
                                        <SearchIcon width={18} height={18} />
                                    </div>
                                    <div className="m-0 ms-3">Search Query Tool</div>
                                </button>
                            </Link>
                        </div>
                    </div>

                    {/* Forms */}

                    <div className="accordion-item bg-transparent">
                        <div className="accordion-header bg-transparent" id="frontDeskItem" style={{ width: "256px" }}>
                            <button
                                className="accordion-button bg-transparent text-light no-border collapsed p-0 m-0 pe-3"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#frontDeskCollapse"
                                aria-controls="frontDeskCollapse"
                                aria-expanded="false"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: "4rem", height: "4rem" }}
                                >
                                    <FrontDeskIcon width={18} height={18} />
                                </div>
                                <div className="m-0 ms-3">Audit</div>
                            </button>
                        </div>
                        <div
                            id="frontDeskCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="frontDeskItem"
                            data-bs-parent="#menuContainer"
                            data-state={isOpen ? "" : "hide"}
                            style={{ width: "256px" }}
                        >
                            <div className="accordion-body p-0">
                                <Link to={url + FRONT_DESK_FORM_LIST_ROUTE}>
                                    <div className="item text-light p-3">List of Forms</div>
                                </Link>
                                <Link to={url + FRONT_DESK_SUBMITTED_FORMS_ROUTE}>
                                    <div className="item text-light p-3">Submitted Forms</div>
                                </Link>
                            </div>
                        </div>
                    </div>

                    {authServices.getaXNzdXBlcmFkbWlu() === "true" && (
                        <div className="bg-transparent" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }}>
                            <div className="bg-transparent" id="searchItem" style={{ width: "256px" }}>
                                <Link to={url + SUBSCRIBER_LIST_ROUTE}>
                                    <button
                                        className="btn search-btn d-flex align-items-center bg-transparent text-light no-border w-100 p-0"
                                        type="button"
                                        aria-expanded="true"
                                        aria-controls="collapseTwo"
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "4rem", height: "4rem" }}
                                        >
                                            <SearchIcon width={18} height={18} />
                                        </div>
                                        <div className="m-0 ms-3 text-start">Subscribers List</div>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    )}

                    {authServices.getaXNzdXBlcmFkbWlu() === "true" && (
                        <div className="bg-transparent" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.125)" }}>
                            <div className="bg-transparent" id="searchItem" style={{ width: "256px" }}>
                                <Link to={url + FREE_ALERT_SUBSCRIBER_LIST_ROUTE}>
                                    <button
                                        className="btn search-btn d-flex align-items-center bg-transparent text-light no-border w-100 p-0"
                                        type="button"
                                        aria-expanded="true"
                                        aria-controls="collapseTwo"
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-center"
                                            style={{ width: "4rem", height: "4rem" }}
                                        >
                                            <SearchIcon width={18} height={18} />
                                        </div>
                                        <div className="m-0 ms-3 text-start">Free Alerts Subscribers List</div>
                                    </button>
                                </Link>
                            </div>
                        </div>
                    )}

                    
                </div>
            </div>
        </div>
    );
};

export default DashboardSidebar;
